module.exports = __webpack_public_path__ + "static/media/IMG_1530.66333b93.JPG";